// does not matter for the extension, put a stub
export const getDaoSupportedNetworks = () => ({
  data: [],
})
